import createCachedSelector from "re-reselect";

const emptyArray = [];
const defaultBankAccount = {
  isLoaded: false
};

export const getBankAccountsData = (state, partnerId) =>
  state.currentOffer.clientBankAccountData.bankAccounts[partnerId] || defaultBankAccount;

export const getBankAccountsIsLoaded = createCachedSelector(getBankAccountsData, bankAccounts => {
  return bankAccounts.isLoaded;
})((_, partnerId) => partnerId);

const getBankAccounts = (state, partnerId) => {
  const partnerBankAccountsData = state.entities.offerPartnerBankAccounts[partnerId];
  return partnerBankAccountsData ? partnerBankAccountsData.bankAccounts : emptyArray;
};

export const getOfferBankAccounts = createCachedSelector(
  getBankAccountsIsLoaded,
  getBankAccounts,
  (isLoaded, bankAccounts) => {
    if (!isLoaded) {
      return emptyArray;
    }
    return bankAccounts;
  }
)((_, partnerId) => partnerId);

export const getBankAccountTypes = state =>
  state.dictionaries.bankAccountTypes.isLoaded ? state.dictionaries.bankAccountTypes.items : emptyArray;

